<img class="pdf" src="../../../assets/pdf.png" matTooltip={{alt}}  (click)="download()"/>{{name}}
